import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Seller } from '@1po/1po-bff-fe-spec/generated/user/model/Seller';
import { updateUserSellerSaga } from 'domains/user';
import { Flex, Text } from 'UI';
import { BlackBox, SellerCardStyled } from './SellerCard.styled';

type SellerCardProps = {
  seller: Seller;
  activeSeller: boolean;
  setSelectedSeller: (seller: Seller) => void;
};

const SellerCard = ({ seller, activeSeller, setSelectedSeller }: SellerCardProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return (
    <SellerCardStyled
      key={seller.id}
      active={activeSeller}
      onClick={() => {
        if (!activeSeller) {
          dispatch(updateUserSellerSaga(seller.id));
          setSelectedSeller(seller);
        }
      }}
      gap={20}
    >
      <BlackBox direction={'column'} justify={'center'} align={'center'}>
        <Text type="lg" bold color="white" cursor={'pointer'}>
          Renault Group
        </Text>
      </BlackBox>
      <Flex direction={'column'} justify={'center'}>
        <Text type="lg" bold cursor={'pointer'}>
          {seller.name}
        </Text>
        <Text type="base" color="grey35" cursor={'pointer'}>
          {t('common.id', 'ID')}: {seller.birCode}
        </Text>
      </Flex>
    </SellerCardStyled>
  );
};

export default SellerCard;
